import { Component, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import "@/App.css";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div
                    className="flex min-h-screen items-center justify-center bg-[#0a0a0a] px-6"
                    data-testid="app-error-boundary"
                >
                    <div className="max-w-md text-center">
                        <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold">
                            Erro inesperado
                        </p>
                        <h1 className="mt-4 font-serif text-3xl text-white">
                            Algo interrompeu esta investigação.
                        </h1>
                        <p className="mt-3 text-sm text-[#888888]">
                            Recarregue a página para continuar.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <Landing />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
